export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_kr-138043ec81e44874bd33bef5d0a53c5a.png";